import $ from 'jquery';
import copy from 'copy-to-clipboard';

class Citation {
    constructor () {
        this.$citationWrapper  = $('.js-citation');
        this.$citationText     = $('.js-citation-text');
        this.$citationButton   = $('.js-citation-button');
        this.$citationCopyText = $('.js-cite-copied');

        // Events
        this.$citationButton.on('click', $.proxy(this.copyCitationToClipboard, this));
    }

    copyCitationToClipboard (e) {
        const $elem         = $(e.currentTarget);
        const $citationText = $elem.closest(this.$citationWrapper).find(this.$citationText);
        const textToCopy    = $citationText.text();

        // Copy to clipboard
        copy(textToCopy);

        this.$citationCopyText.addClass('is-visible');

        setTimeout(() => {
            this.$citationCopyText.removeClass('is-visible');
        }, 3000);
    }
}

export default Citation;
